import { getDatasetType, getSchemeFromTilesetDataset } from 'features/builder/state/builderSliceUtils'
import { KeplerTable, LayerTypes, TilingScheme } from 'features/builder/types'
import { MapType } from 'features/maps/types'
import IconQuadbin from 'assets/icons/layers/quadbin.svg?react'
import SpatialIndexLayer from './SpatialIndexLayer'

export default class QuadbinLayer extends SpatialIndexLayer {
  public get type() {
    return LayerTypes.Quadbin
  }

  get name() {
    return 'Quadbin'
  }

  get layerIcon() {
    return IconQuadbin
  }

  static findDefaultLayerProps(dataset: KeplerTable, foundLayers) {
    const emptyProps = { props: [] }

    if (foundLayers?.length) {
      return emptyProps
    }
    const scheme = getSchemeFromTilesetDataset(dataset)

    if (getDatasetType(dataset) === MapType.tileset && scheme === TilingScheme.Quadbin) {
      return {
        props: [
          {
            label: dataset.label,
            isVisible: true,
            columns: {}
          }
        ]
      }
    }
    return emptyProps
  }
}
